<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Pemekaran Wilayah</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <select class="form-control" v-model="tab">
                            <option>Pindah Kelurahan Keseluruhan ke Kecamatan Lain</option>
                            <option>Gabung Beberapa Blok</option>
                            <option>Pindah Blok Keseluruhan ke Kelurahan Lain</option>
                            <option>Pindah NOP ke Blok Lain</option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <div v-if ="tab == 'Pindah Kelurahan Keseluruhan ke Kecamatan Lain'">
                    <bhumie_pemekaran_wilayah_tab1></bhumie_pemekaran_wilayah_tab1>
                </div>

                <div v-if ="tab == 'Gabung Beberapa Blok'">
                    <bhumie_pemekaran_wilayah_tab2></bhumie_pemekaran_wilayah_tab2>
                </div>

                <div v-if ="tab == 'Pindah Blok Keseluruhan ke Kelurahan Lain'">
                    <bhumie_pemekaran_wilayah_tab3></bhumie_pemekaran_wilayah_tab3>
                </div>

                <div v-if ="tab == 'Pindah NOP ke Blok Lain'">
                    <bhumie_pemekaran_wilayah_tab4></bhumie_pemekaran_wilayah_tab4>
                </div>


        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab: "Pindah Kelurahan Keseluruhan ke Kecamatan Lain",
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
